import { useEffect, useState } from "react";
import * as services from "./../services/customer";

export function useCustomers(customerType) {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    services
      .getCustomers(customerType)
      .then((res) => isMounted && setCustomers(res.data.data))
      .catch((err) => console.error(err))
      .finally(() => isMounted && setLoading(false));
    return () => {
      isMounted = false;
    };
  }, [customerType]);

  return { customers, loading };
}
